<template>
    <div>
        <div class="list-category">
            <draggable
                v-model="datacat"
                class="item-category"
                group="ingedientes"
                @start="isDragging = true"
                @end="isDragging = false"
                @change="moveCat"
                handle=".moveCat"
            >
                <div v-for="(i, index) in datacat" :key="index">
                    <div
                        :class="[
                            'category-view',
                            i.view === 1 ? 'category-view-form' : '',
                            activeIndex === index ? 'active' : '',
                        ]"
                    >
                        <div class="load" v-if="isLoading && activeIndex === index">
                            <loader></loader>
                        </div>
                        <div class="moveCat"><i class="fas fa-ellipsis-v"></i></div>
                        <div class="row">
                            <div class="verPlatos">
                                <!-- <div
                                    class="boton"
                                    @click="cancelarCat(index, i)"
                                    v-if="i.view === 1"
                                > -->
                                <div
                                    class="boton"
                                    @click="eventoClicCat(i, index, 'cancelarCat')"
                                    v-if="i.view === 1"
                                >                                
                                    <span style="text-align: center;display: block;">X</span>
                                </div>
                                <div
                                    class="boton save"
                                    @click="saveCat(i, index)"
                                    v-if="i.view === 1"
                                >
                                    Ok
                                </div>                                
                                <span class="cdropdown btnViewMore" v-if="i.view === 2">
                                    <button><i class="fas fa-ellipsis-v"></i></button>
                                    <label>
                                        <input type="checkbox" />
                                        <ul>
                                            <!-- <li @click="removeCat(i,index)">{{$t("lang.label_del")}}</li> -->
                                            <li @click="restoreCat(i, index)">
                                                {{ $t("lang.label_del") }}
                                            </li>
                                            <li @click="changeGroup(i, index)">
                                                {{ $t("lang.label_change_group") }}
                                            </li>
                                        </ul>
                                    </label>
                                </span>
                            </div>
                            <div class="botonera">
                                <div class="boton swich" v-if="i.view === 2">
                                    <div class="onoffswitch">
                                        <input
                                            type="checkbox"
                                            :id="'cat' + i.id"
                                            :checked="i.status"
                                            class="onoffswitch-checkbox"
                                            @click="changeStatus('status', i)"
                                        />
                                        <label
                                            class="onoffswitch-label"
                                            :for="'cat' + i.id"
                                        >
                                            <span class="onoffswitch-inner"></span>
                                            <span class="onoffswitch-switch"></span>
                                        </label>
                                    </div>
                                </div>
                                <!-- <div class="boton add" v-if="i.view === 2 && i.opts !== ''" @click="addFood(i, index)"> -->
                                <div class="boton add" v-if="i.view === 2" @click="eventoClicCat(i, index, 'addFood')">
                                <!-- <div class="boton add" v-if="i.view === 2" @click="addFood(i, index)"> -->
                                    <i class="fas fa-plus fa-lg"></i>
                                </div>
                                <div v-if="i.is_file && i.view === 2" class="btn_pic img">
                                    <i class="fas fa-image" style="font-size: 20px; cursor: pointer" @click="showImagePreview(i)"></i>
                                </div>
                                <div class="boton edit" @click="editCat('', i)" v-if="i.view === 2">
                                    <i class="fas fa-pencil-alt" style="font-size: 11px"></i>
                                </div>
                                <!-- <div class="boton config" @click="verPlatos(i)" v-if="i.view === 2 && i.opts !== ''"> -->
                                <div class="boton config" @click="verPlatos(i)" v-if="i.view === 2">
                                    <i class="fas fa-chevron-up" v-if="i.verPlatos === true"></i>
                                    <i class="fas fa-chevron-down" v-else></i>
                                </div>
                            </div>
                            <div class="content-cat" @click="eventoClicCat(i, index, 'ActiveItem')">
                            <!-- <div class="content-cat" @click="ActiveItem(i, index)"> -->
                                <div class="portada-cat imgCropperjs" :style="{'background-image': 'url(' +require('@/assets/pic_special.png') +')',}">
                                    <div class="imgpreview" @click="displayRef('picture_img' + i.id)">
                                        <div class="error_img" v-if="i.error_image === true">
                                            {{ $t("lang.msj_img_err_size_exceeded") }}
                                        </div>
                                        <div v-if="i.is_file">
                                            <img :src="i.url + 'small/' + i.image" :id="'logo_category' + i.id"
                                                v-bind:class="[{ noneImg: i.is_file === false }, 'image_category' + i.id]"
                                                :alt="i.image"
                                            />
                                        </div>
                                        <i class="fas fa-picture"></i>
                                    </div>
                                    <div class="actionImg">
                                        <button
                                            type="button"
                                            v-bind:class="[
                                                { noneImg: i.is_file === false },
                                                'btn btn-danger deleteImg',
                                            ]"
                                            @click="deleteImgCat(i, index)"
                                        >
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>
                                    <div class="btns_action">
                                        <button
                                            type="button"
                                            v-bind:class="[
                                                { noneImg: i.is_file === false },
                                            ]"
                                            @click="rotateImgCat(90, i)"
                                        >
                                            <i class="fas fa-undo"></i>
                                        </button>
                                        <button
                                            type="button"
                                            v-bind:class="[
                                                { noneImg: i.is_file === false },
                                            ]"
                                            @click="rotateImgCat(-90, i)"
                                        >
                                            <i class="fas fa-redo"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="data-zone">
                                    <input
                                        type="file"
                                        style="display: none"
                                        :ref="`picture_img${i.id}`"
                                        accept="image/jpeg,image/jpg"
                                        @change="fileportada($event, i, index)"
                                    />
                                    <div class="float-left">
                                        <input
                                            type="text"
                                            v-model="i.name"
                                            maxlength="50"
                                            placeholder="Nombre de la categoria"
                                            class="form-control c-category"
                                            v-if="i.view === 1"
                                        />
                                        <h4 v-else>
                                            {{ i.name }}
                                        </h4>
                                    </div>
                                    <div class="float-left">
                                        <textarea
                                            v-model="i.description"
                                            maxlength="500"
                                            placeholder="Descripcion"
                                            class="form-control c-category"
                                            v-if="i.view === 1"
                                        ></textarea>
                                        <p class="item-description" v-else>
                                            {{ i.description }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <menufood :foodItems="i"></menufood>
                </div>
            </draggable>
            <div class="row">
                <div class="col-md-12" v-if="datacat.length === 0">
                    <div class="groupTextEmptyFont">
                        <p class="groupTextEmpty">
                            <strong>Cree su primera comida</strong>
                        </p>
                        <button
                            type="button"
                            class="btn btn-add-groupEmpty"
                            id="ntb"
                            @click="addCat"
                        >
                            {{ $t("lang.label_add_ctgory") }}
                        </button> 
                    </div>               
                </div>
                <div class="col-md-3" v-else>
                    <button
                        type="button"
                        class="btn btn-add-group"
                        id="ntb"
                        @click="addCat"
                    >
                        {{ $t("lang.label_add_ctgory") }}
                    </button>
                </div>
            </div>
        </div>
        <modal
            name="modal_image_preview"
            height="auto"
            width="800px"
            :resizable="true"
            :adaptive="true"
            :scrollable="true"
        >
            <div class="card-header">
                {{ product_name_preview }}
                <button @click="closeModal" class="closeIcon"><span></span></button>
            </div>
            <div class="card-body">
                <img
                    :src="image_preview_modal"
                    style="
                        text-align: center;
                        display: block;
                        margin: 0 auto;
                        max-width: 100%;
                    "
                    alt=""
                />
            </div>
        </modal>
        <modal
            name="modal_changeGroup"
            height="auto"
            width="400px"
            :resizable="true"
            :adaptive="true"
            :scrollable="true"
        >
            <div class="card-header">
                {{ $t("lang.label_change_group") }}
                <span class="badge badge-info">{{ catSelect.name }}</span>
                <button @click="closeModalChangeGroup" class="closeIcon">
                    <span></span>
                </button>
            </div>
            <div class="card-body">
                <form @submit.prevent="saveChangeGroup">
                    <div class="form-group">
                        <select class="form-control" v-model="groupSelect">
                            <option
                                v-for="(i, index) in groups"
                                :key="index"
                                :value="i.id"
                            >
                                {{ i.name }}
                            </option>
                        </select>
                    </div>
                    <button type="submit" class="btn btn-primary">Cambiar</button>
                </form>
            </div>
        </modal>
        <!-- <modal name="cropper" height="370px" width="645px">
            <demox></demox>
        </modal> -->
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader.vue";
import menufood from "@/components/dimenu/menu/menu_food.vue";
import EventBus from "@/eventBus";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
// import demox from "@/components/dimenu/menu/demox";
export default {
    name: "menu_cat",
    components: {
        Loader,
        menufood,
        draggable,
        // demox,
    },
    display: "Clone",
    order: 2,
    props: {
        categoryItems: { type: Array, required: true },
    },
    data () {
        return {
            isLoading: false,
            action: "",
            portada: null,
            logo_category: "src",
            datacat: [],
            activeIndex: null,
            category: {
                id_category: null,
                image_category: null,
            },
            index_category: null,
            image_preview_modal: null,
            product_name_preview: "",
            isDragging: false,
            cancelAside: true,
            imageUpload: null,
            imageActual: null,
            groupSelect: 0,
            idgrupo:0,
            groups:[],
            catSelect: {},
            dateShow: false,
            dateCrop: [],
            srcz: "",
            actions: null,
            validar:[], 
            options:[],            
        }
    },
    created () {
        let g = this.$store.getters["getOpenModal"];
        if (g.data.group !== undefined) {
            this.groupSelect = g.data.group 
            this.loadGrup()
        }
        let vm = this;
        EventBus.$on("newCategory", (data) => {
            // console.log(data);
            this.isLoading = false;
            vm.action = "create";
            EventBus.$off("newCategory");
        });
        EventBus.$on("showModalFood", (data) => {
            vm.product_name_preview = data.name;
            vm.image_preview_modal = data.image;
            vm.$modal.show("modal_image_preview");
        });
        this.init(this.get_listCategores);
    },
    methods: {
        eventoClicCat(i, index, actionx){
            switch(actionx) {
                case 'cancelarCat':
                    this.cancelarCat(i, index)   
                    break;
                case 'addFood':
                    if (i.opts === "" || i.opts === null) { i.opts = "multizise" }
                    this.addFood(i, index)                
                    break;
                case 'ActiveItem':
                    if (i.platos.length === 0) { i.opts = "" }
                    this.ActiveItem(i, index) 
                    break;
            }             
            // console.log(i);
            // console.log(index);
            // console.log(actionx);
        },        
        toggleShow(i, index) {
            console.log(i, index);
            // this.srcz = [
            //     {
            //         action: true,
            //         i: i,
            //         index: index,
            //     },
            // ];
            // let t = this.srcz;
            // let data = [];
            // data.push({
            //     function: "SendData",
            //     dat: t,
            // });
            // this.$store.commit("setCropperImagenes", data);
            // this.$modal.show("cropper");
        },
        init(d) {
            let u = Array();
            let count = 0;
            for (const i in d) {
                let platos = d[i].platos;
                let entries = Object.entries(platos);
                let yt = [];
                for (let i in entries) {
                    let element = entries[i];
                    for (let y in element) {
                        if (typeof element[y] !== "string") {
                            let rl = element[y];
                            if (typeof rl === "object") {
                                yt.push(rl);
                            }
                        }
                    }
                }
                if (platos.length > 0) {
                    count = count + 1;
                    if (count === 1) {
                        u.push({
                            opts: d[i].opts,
                            description: d[i].description,
                            error_image: d[i].error_image,
                            group_id: d[i].group_id,
                            id: d[i].id,
                            image: d[i].image,
                            is_file: d[i].is_file,
                            name: d[i].name,
                            org_id: d[i].org_id,
                            // platos: d[i].platos,
                            platos: yt,
                            sizes: d[i].sizes,
                            small: d[i].small,
                            status: d[i].status,
                            url: d[i].url,
                            user_id: d[i].user_id,
                            verPlatos: true,
                            view: d[i].view,
                            type: d[i].type,
                        });
                    } else {
                        u.push({
                            opts: d[i].opts,
                            description: d[i].description,
                            error_image: d[i].error_image,
                            group_id: d[i].group_id,
                            id: d[i].id,
                            image: d[i].image,
                            is_file: d[i].is_file,
                            name: d[i].name,
                            org_id: d[i].org_id,
                            // platos: d[i].platos,
                            platos: yt,
                            sizes: d[i].sizes,
                            small: d[i].small,
                            status: d[i].status,
                            url: d[i].url,
                            user_id: d[i].user_id,
                            verPlatos: false,
                            view: d[i].view,
                            type: d[i].type,
                        });
                    }
                } else {
                    u.push({
                        opts: d[i].opts,
                        description: d[i].description,
                        error_image: d[i].error_image,
                        group_id: d[i].group_id,
                        id: d[i].id,
                        image: d[i].image,
                        is_file: d[i].is_file,
                        name: d[i].name,
                        org_id: d[i].org_id,
                        // platos: d[i].platos,
                        platos: yt,
                        sizes: d[i].sizes,
                        small: d[i].small,
                        status: d[i].status,
                        url: d[i].url,
                        user_id: d[i].user_id,
                        verPlatos: false,
                        view: d[i].view,
                        type: d[i].type,
                    });
                }
                count++;
            }
            this.datacat = u;
            this.openSendCategory();
            this.getGroup()
        },
        rotateImgCat(angle, i) {
            this.isLoading = true;
            window.master
                .post("/rotate", {
                    org_id: window.localuserdata,
                    user_id: window.master_client,
                    prefijo: "image",
                    angle: angle,
                    type: "cat",
                    img: i.image,
                    small: i.small,
                    id: i.id,
                })
                .then((response) => {
                    console.log(response);
                    this.refreshCategores();
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteImgCat(i, index) {
            this.$swal({
                title: window.lang2.del_image,
                text: window.lang2.msj_you_sure,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: window.lang2.msj_del_it,
            }).then((result) => {
                if (result.value) {
                    this.datacat[index].is_file = false;
                    window.master
                        .post("/menu/category/delimg", {
                            id: i.id,
                            org_id: window.localuserdata,
                            user_id: window.master_client,
                        })
                        .then((response) => {
                            console.log(response);
                            EventBus.$emit("ClearAside");
                        })
                        .catch((error) => console.log(error));
                }
            });
        },
        restoreCat(i, index) {
            this.$swal({
                title: window.lang2.msj_del_ctgory,
                text: window.lang2.msj_you_sure,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: window.lang2.msj_del_it,
            }).then((result) => {
                if (result.value) {
                    this.datacat.splice(index, 1);
                    if (i.platos.length === 0) {
                        this.removerCat(i);
                    } else {
                        window.master
                            .post("/menu/category/restore", {
                                id: i.id,
                                org_id: window.localuserdata,
                                user_id: window.master_client,
                            })
                            .then((response) => {
                                console.log(response);
                                EventBus.$emit("ClearAside");
                            })
                            .catch((error) => console.log(error));
                    }
                }
            });
        },
        removerCat(i) {
            window.master
                .delete("menu/category/delete/" + i.id + "/" + window.localuserdata, {
                    data: i,
                    org_id: window.localuserdata,
                    user_id: window.master_client,
                })
                .then((response) => {
                    // console.log(response);
                    EventBus.$emit("ClearAside");
                })
                .catch((error) => console.log(error));
        },
        saveChangeGroup() {
            window.master
                .post("changegroup", {
                    new_group: this.groupSelect,
                    cat_id: this.catSelect.id,
                })
                .then((response) => {
                    console.log(response);
                    this.refreshCategores();
                })
                .catch((error) => {
                    console.log(error);
                    this.isloading = false;
                });
        },
        refreshCategores() {
            let i = { id: this.get_groupActive };
            this.$store
                .dispatch("getCategories", i)
                .then((response) => {
                    this.closeModalChangeGroup();
                    console.log("category list base", response);
                    this.$store.commit("SET_LISTCATEGORES", response);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        changeGroup(i) {
            this.groupSelect = i.group_id;           
            this.catSelect = i;
            this.$modal.show("modal_changeGroup");
        },
        closeModalChangeGroup() {
            this.groupSelect = 0;
            this.$modal.hide("modal_changeGroup");
        },
        displayRef(ref) {
            this.$refs[ref][0].click();
        },
        showImagePreview(i) {
            this.product_name_preview = i.name;
            this.image_preview_modal = i.url + "large/" + i.image;
            this.$modal.show("modal_image_preview");
            document.styleSheets[0].addRule(
                "div.v--modal-box.v--modal",
                "top: 120px !important"
            );
        },
        closeModal() {
            this.$modal.hide("modal_image_preview");
        },
        ActiveItem(i, index) {                 
            this.category.id_category = i.id;
            this.imageActual = i.image;
            this.activeIndex = index;
            let existFoods = false;
            let sizesAll = [];
            let swich = false;
            if (i.platos.length) {
                existFoods = true;
            }
            let existSizes = false;
            // if (i.sizes.length > 1) {
                existSizes = true;
                sizesAll = i.sizes;
                swich = true;
            // }

            let data = {
                opts: i.opts,
                id: i.id,
                org_id: i.org_id,
                user_id: i.user_id,
                name: i.name,
                verPlatos: true,
                existFoods: existFoods,
                existSizes: existSizes,
                sizesList: sizesAll,
                swich: swich,
                id_category: i.id,
                type: i.type,
            };
            if (i.view === 2) {
                let emit = { cat: i, key: index, retorno: 1 };
                if (this.cancelAside) {
                    this.$store.commit("SET_CAT_ACTIVE", emit);
                    this.$store.commit("SET_CAT_DATA_ASIDE", data);                   
                } else {
                    this.cancelAside = true;
                }
            }
        },
        LogoCategory(i, id) {
            this.$refs["picture_img" + id].click();
        },
        fileportada(event, i, index) {
            this.datacat[index].error_image = false;
            this.index_category = index;
            let self = this;
            this.category.id_category = i.id;
            this.category.image_category = event.target.files[0];
            /* console.log('size', event.target.files[0].size * 1024 * 1024 )
			if(event.target.files[0].size > 30000){
			console.log('mas de 3o mb')
			}
			return; */
            if (event.target.files && event.target.files[0]) {
                var reader = new FileReader();
                i.is_file = true;
                reader.readAsDataURL(event.target.files[0]);
                let img = new Image();
                reader.onload = function (e) {
                    img.src = e.target.result;
                    img.onload = function () {
                        // if (this.width > 1199 && this.height > 899) {  
                            document.querySelector(".image_category" + i.id).src =
                                e.target.result;
                            self.category.image_category = e.target.result;
                            self.imageUpload = event.target.files[0];
                            if (i.view !== 1) {
                                self.subirImage(index);
                            }                            
                        // } else {
                        //     document.querySelector(".image_category" + i.id).src =""
                        //     self.category.image_category = ""
                        //     self.imageUpload = ""
                        //     i.is_file = false
                        //     self.$swal({
                        //         title: "Error",
                        //         text: "El alto debe ser mayor 1199px y el ancho debe ser mayor 899px",
                        //         type: "warning",
                        //         showCancelButton: false,
                        //     });
                        //     self.isLoading = false
                        // }
                    }
                };
            }        
        },
        subirImage(index) {
            this.isLoading = true;
            let self = this;
            let fileSendHeader = { headers: { "Content-Type": "multipart/form-data" } };
            let formData = new FormData();
            // formData.append("file", this.category.image_category);
            formData.append("file", this.imageUpload);
            formData.append("id", this.category.id_category);
            formData.append("image", this.imageActual);
            formData.append("org_id", window.localuserdata);
            formData.append("user_id", window.master_client);
            window.master
                .post("/upload/category", formData, fileSendHeader)
                .then((response) => {
                    if (response.data.image_large) {
                        self.categoryItems[index].error_image = true;
                        return;
                    }
                    self.categoryItems[index].error_image = false;
                    this.imageActual = response.data.logo;
                    this.imageUpload = null;
                    this.datacat[index].url = response.data.url;
                    this.datacat[index].image = response.data.logo;
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                });
        },
        getDataSelected() {
            let f = {
                org_id: window.localuserdata,
                user_id: window.master_client,
                agruparOpt:[],
            }
            let url = "/menu/variantopts";
            window.master
                .post(url, f)
                .then((response) => {
                    this.options = []
                    let u = response.data.res;
                    this.options = u;
                })
                .catch((error) => {
                    console.log(error);
                });
        },         
        getDataCreate() {
            let f = {
                org_id: window.localuserdata,
                user_id: window.master_client,
            }            
            let url = "/menu/variantcat";
            window.master
                .post(url, f)
                .then((response) => {
                    this.validar = response.data.res;
                })
                .catch((error) => {
                    console.log(error);
                });
        }, 
        varianteForm(){
            this.getDataSelected()
            this.getDataCreate() 
            let t = this
            setTimeout(function () {
                t.$store.commit("setnewFoodCat", {validar:t.validar, options:t.options});
            }, 3000);        
        },               
        addFood(i, index) {
            this.actions = i.opts
            this.$store.commit("SET_ACCTION_ADD_FOOD", true);
            this.varianteForm()            
            // EventBus.$emit("newFood");
            let agruparOpt = [];
            let multiSizes = i.sizes;
            let sizes = [];
            if (this.actions === "multizise" || this.actions === null || this.actions === '') {
                for (let s in multiSizes) {
                    sizes.push({
                        size_id: multiSizes[s].id,
                        name_size: multiSizes[s].name,
                        price: "0.10",
                        required: true,
                    });
                }            
            }    
            i.verPlatos = true;     
            let check = i.platos.filter((item) => item.id === 0);
            if (check.length < 1) {
                i.platos.push({
                    id: 0,
                    view: 1,
                    name: "",
                    description: "",
                    price: 0,
                    img: "",
                    error_image: false,
                    status: true,
                    is_file: false,
                    edit: true,
                    isSize: true,
                    prices: sizes,
                    type: "food",
                    agruparOpt: agruparOpt,
                });
            }

            if (this.actions !== null) {
                let t = this;
                let data = {
                    function: "ActiveAction",
                    actions: t.actions,
                };
                this.$store.commit("setvariantData", data);
            }
        },
        addCat() {
            this.imageUpload = null;
            this.action = "create"; //let
            let check = this.datacat.filter((item) => item.id === 0);
            let t = this
            if (check.length < 1) {
                this.datacat.push({
                    description: "",
                    error_image: false,
                    group_id: t.groupSelect,
                    id: 0,
                    image: "",  
                    is_file: false,      
                    name: "",
                    opts:"",                                        
                    portada: "",                                        
                    status: true,
                    type: "category",
                    platos: [],
                    sizes: [],
                    verPlatos: false,
                    view: 1,                   
                });
            }
            this.loadGrup()
        },
        editCat(action, i) {
            // console.log(action, i);
            this.action = "update";
            i.view = 1;
            this.category.id_category = i.id;
            this.imageActual = i.image;
        },
        cancelarCat(i, index) {
            if (this.datacat[index].id === 0) {
                this.datacat.splice(index, 1);
            } else {
                this.action = ""
                i.view = 2
                this.category.id_category = null
                this.imageActual = null
            }
        },
        changeStatus(action, i) {
            var active = 0;
            if (i.status) {
                active = 0;
            } else {
                active = 1;
                //i.view=1;
            }
            window.master
                .put("menu/category/status/" + i.id, {
                    org_id: window.localuserdata,
                    status: active,
                })
                .then((response) => {
                    i.status = !i.status;
                    console.log(response);
                })
                .catch((error) => console.log(error));
        },
        verPlatos(i) {
            i.verPlatos = !i.verPlatos;
        },
        saveCat(i, index) {
            this.isLoading = true;
            this.activeIndex = index;
            let fileSendHeader = { headers: { "Content-Type": "multipart/form-data" } };
            let existFoods = false;
            let sizesAll = [];
            let swich = false;
            if (i.platos.length) {
                existFoods = true;
                swich = true;
            }
            let existSizes = false;
            if (i.sizes.length > 1) {
                existSizes = true;
                sizesAll = i.sizes;
            }

            let data = {
                id: i.id,
                org_id: window.localuserdata,
                user_id: window.master_client,
                name: i.name,
                verPlatos: true,
                existFoods: existFoods,
                existSizes: existSizes,
                sizesList: sizesAll,
                swich: swich,
            };
            i.view = 2;

            if (i.name === null || i.name === "") {
                this.datacat.splice(index, 1);
                this.cancelAside = false;
                this.isLoading = false;
                return false;
            }
            this.cancelAside = true;
            let formData = new FormData();
            formData.append("file", this.imageUpload);
            formData.append("id", this.category.id_category);
            formData.append("image", this.imageActual);
            formData.append("org_id", window.localuserdata);
            formData.append("user_id", window.master_client);
            formData.append("group_id", this.get_groupActive);
            formData.append("name", i.name);
            formData.append("description", i.description);
            formData.append("status", 1);
            // console.log(this.category.id_category);
            if (this.category.id_category === 0) {
                this.action = "create";
            } else {
                this.action = "update";
            }
            if (this.action === "create") {
                window.master
                    .post("menu/category/add", formData, fileSendHeader)
                    .then((response) => {
                        this.isLoading = false;
                        if (response.data.image_large) {
                            this.datacat[index].error_image = true;
                            return;
                        }
                        this.imageUpload = null;
                        this.action = "";
                        this.imageActual = response.data.image;
                        this.datacat[index].url = response.data.url;
                        this.datacat[index].image = response.data.image;
                        this.datacat[index].id = response.data.id;
                        this.datacat[index].sizes.push({
                            id: response.data.size_id,
                            name: "Price",
                        });

                        let swich = false
                        let existSizes = false;
                        let existFoods = false;
                        let data = {
                            opts: i.opts,
                            id: response.data.id,
                            org_id: i.org_id,
                            user_id: i.user_id,
                            name: i.name,
                            verPlatos: true,
                            existFoods: existFoods,
                            existSizes: existSizes,
                            sizesList: response.data.sizeMulti,
                            swich: swich,
                            id_category: response.data.id,
                            type: this.datacat[index].type,
                        };
                        let emit = { cat: i, key: index, retorno: 1 };
                        this.$store.commit("SET_CAT_ACTIVE", emit);
                        this.$store.commit("SET_CAT_DATA_ASIDE", data);
                        this.getGroup()                 
                    })
                    .catch((error) => console.log(error));
            } else if (this.action === "update") {
                if (i.image !== null || i.image !== "") {
                    this.datacat[index].image = i.image;
                } else {
                    i.image = "";
                }
                window.master
                    .post("menu/category/update/" + i.id, formData, fileSendHeader)
                    .then((response) => {
                        this.isLoading = false;
                        if (response.data.image_large) {
                            this.datacat[index].error_image = true;
                            return;
                        }
                        this.imageUpload = null;
                        this.action = "";
                        this.datacat[index].url = response.data.url;
                        this.datacat[index].image = response.data.image;
                        this.imageActual = response.data.image;
                        if (i.opts !== "") {
                            let emit = { cat: i, key: index, retorno: 1 };
                            this.$store.commit("SET_CAT_ACTIVE", emit);
                        }
                    })
                    .catch((error) => console.log(error));
            }
        },
        removeCat(i, index) {
            this.$swal({
                title: window.lang2.msj_del_ctgory,
                text: window.lang2.msj_you_sure,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: window.lang2.msj_del_it,
            }).then((result) => {
                if (result.value) {
                    /* if(this.datacat.length > 1){
					this.datacat.splice(index, 1);
					} */
                    this.datacat.splice(index, 1);
                    window.master
                        .delete(
                            "menu/category/delete/" + i.id + "/" + window.localuserdata,
                            {
                                org_id: window.localuserdata,
                                user_id: window.master_client,
                            }
                        )
                        .then((response) => {
                            console.log(response);
                            EventBus.$emit("ClearAside");
                        })
                        .catch((error) => console.log(error));
                }
            });
        },
        log: function (evt) {
            window.console.log(evt);
        },
        initEventBus() {
            this.openSendCategory();
        },
        openSendCategory() {
            EventBus.$on("sendCategory", (data) => {
                if (data.retorno === 1) {
                    this.datacat[data.key] = data.cat;
                    this.closeEvenBus(data);
                }
            });
        },
        closeEvenBus(data) {
            if (data.retorno === 1) {
                data.retorno = 0;
                EventBus.$off("sendCategory");
            }
            if (data.retorno === 0) {
                this.initEventBus();
            }
        },
        moveCat() {
            window.master
                .put("movecat", {
                    org_id: window.localuserdata,
                    user_id: window.master_client,
                    cat: this.datacat,
                })
                .then((response) => {
                    // console.log(response);
                })
                .catch((error) => console.log(error));
        },
        subirImageFood(event, p, index, blob) {
            let fileSendHeader = { headers: { "Content-Type": "multipart/form-data" } };
            let formData = new FormData();
            formData.append("file", blob);
            formData.append("old", p.image);
            formData.append("opts", p.opts);
            formData.append("image", p.image);
            formData.append("id", p.id);
            formData.append("org_id", window.localuserdata);
            formData.append("user_id", window.master_client);
            window.master
                .post("/upload/food", formData, fileSendHeader)
                .then((response) => {
                    let id = p.category_id;
                    let r = this.datacat;
                    for (let i in r) {
                        if (r[i].id === id) {
                            if (response.data.image_large) {
                                this.datacat[i].platos[index].error_image = true;
                                return;
                            }
                            this.datacat[i].platos[index].url = response.data.url;
                            this.datacat[i].platos[index].image = response.data.image;
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getGroup() {
            window.master
                .get("getgroup/" + window.master_client + "/" + window.localuserdata)
                .then((response) => {
                    this.groups = []
                    let e = response.data.result;
                    for (let i in e) {
                        this.groups.push({
                            id: e[i].id,
                            name: e[i].name,
                            active: e[i].active,
                            visible: 0,
                            primary_group:e[i].primary_group
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        loadGrup(){
            let r = this.datacat
            for (const i in r) {
                r[i].group_id = this.idgrupo
            }
        },   
    },
    watch: {
        getCropperImagenes: function () {
            let data = this.getCropperImagenes[0];
            if (data.function === "uploadCrop") {
                // console.log(data);
                let i = data.i;
                let event = data.event;
                let index = data.index;
                let blob = data.dat;
                if (i.id > 0) {
                    this.subirImageFood(event, i, index, blob);
                }
                // this.menu_item.menu_image = event.target.files[0];
                // this.imageUpload = data.dat
                // this.imageActual = data.dat
                // let i = data.i
                // let index = data.index
                // this.category.id_category=i.id
                // this.saveCat(i,index)
                // this.subirImage(index)
            }
        },
        get_retornoAside: function () {
            this.datacat[this.get_retornoAside.key].sizes = this.get_retornoAside.nsizes;
        },
        get_groupActive: function () {
            //console.log('get_groupActive', this.get_groupActive)
        },
        groupSelect: function () {
            // console.log("groupSelect", this.groupSelect);
            if (typeof this.groupSelect !== 'string' && this.groupSelect > 0){
                this.idgrupo = this.groupSelect
                this.loadGrup()
            }
        },
        get_listCategores: function () {
            // console.log("get_listCategores");
            this.datacat = this.get_listCategores;
        },
        getvariantData() {            
            let functions = this.getvariantData.function;
            if (functions === "variants") {
                let id = this.getvariantData.id;
                let sizesList = this.getvariantData.sizesList;
                let actions = this.getvariantData.actions;
                let activeIndex = this.getvariantData.activeIndex;
                if (activeIndex !== undefined) {
                    // this.activeIndex = activeIndex;
                }

                this.actions = actions;
                let sizes = false;
                if (actions === null) {
                    sizes = true;
                }
                let r = this.datacat;
                for (let i in r) {
                    if (r[i].id === id) {
                        this.datacat[i].opts = actions;
                        if (sizes === true) {
                            this.datacat[i].sizes = [];
                        }
                        if (actions === "multizise") {
                            // r[i].sizes = []
                            // r[i].sizes = sizesList
                            // console.log(r[i]);
                            if (this.getvariantData.activeFoodCero === true) {
                                this.datacat[i].verPlatos = true
                            }                                
                        } else {
                            this.datacat[i].verPlatos = true                           
                        }
                    }
                }                        
                // console.log(this.datacat);
            }
            if (functions === "returnVariant") {
                // console.log(this.getvariantData);
                // console.log(this.datacat);
                let r = this.datacat;
                let idCat = this.getvariantData.idCat;
                let idFood = this.getvariantData.idFood;
                let platosPrices = this.getvariantData.platosPrices;
                let agruparOpt = this.getvariantData.agruparOpt;
                let ar = []
                for (let i in r) {
                    if (r[i].id === idCat) {
                        let o = r[i].platos;
                        let ar = []
                        for (let y in o) {
                            if (o[y].id === idFood) {
                                // console.log(this.datacat[i].platos[y]);
                                // this.datacat[i].platos[y] = []
                                // this.datacat[i].platos[y] = platosPrices
                                o[y].prices = [];
                                o[y].prices = platosPrices;
                                o[y].agruparOpt = [];
                                o[y].agruparOpt = agruparOpt;
                                
                            }
                        }
                    }
                }
                // this.$store.commit("setvariantData", []);
            }
            if (functions === "variantsFood") {
                // this.activeIndex = null   
            }            
        },
        "get_groupList": function () {
            // console.log(this.get_groupList);
        },    
    },
    computed: {
        ...mapGetters([
            "get_retornoAside",
            "get_groupActive",
            "get_groupList",
            "get_listCategores",
            "getCropperImagenes",
            "getvariantData",
        ]),
        dragOptions() {
            return {
                animation: 200,
                group: "ingedientes",
                disabled: false,
                ghostClass: "ghost",
            };
        },
        /* newfoodAction() {
		return this.$store.getters.newfoodAction;
		}, */
    },
}
</script>
<style lang="scss" scoped>
#ntb {
    width: auto !important;
}
.load {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 10;
}
.op-loading {
    position: relative;
    height: 80px;
}
.error_img {
    font-size: 10px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #fa5838;
    color: #fff;
    line-height: 11px;
    text-align: center;
    padding: 5px 0;
    height: 100%;
    padding-top: 14px;
    z-index: 10;
}
.moveCat {
    position: absolute;
    top: 0;
    left: -10px;
    width: 9px;
    height: 100%;
    background-color: #bfe8fb;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: move;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
}
.active {
    border: 1px solid #01b04c !important;
    background-color: #ebfff4 !important;
}
.btn-add-group {
    background-color: #fff;
    border-color: #ccc;
    cursor: pointer;
    position: relative;
    color: #666;
    width: 100% !important;
    position: absolute;
    display: block;
    z-index: 1;    
}
.btn-add-group:hover {
    color: #212529;
    background-color: #e0e0e0;
    border-color: #b3b2b2;
}
.list-category {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0px 15px 15px 15px;
    position: absolute;
    height: calc(100vh - 10vw);
    overflow: hidden;
    overflow-y: scroll;
    margin-top: 20px;
}
.list-category::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    width: 10px;
    background-color: #f5f5f5;
}
.list-category::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
}
.list-category::-webkit-scrollbar-thumb {
    background-color: #222223;
}
.item-category {
    width: 100%;
}
.c-category {
    margin-bottom: 10px;
    border: 1px solid #a5a5a4;
    border-radius: 6px;
    font-size: 0.8rem;
}
.category-view {
    display: flex;
    flex-direction: column;
    padding-left: 10px;
    position: relative;
    max-width: 650px;
    background-color: #fff;
    margin-bottom: 5px;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #a5a5a4;
}
.category-view-form {
    height: 120px;
}
.portada-cat {
    position: relative;
    width: 64px;
    height: 64px;
    overflow: hidden;
    background-size: 64px 64px;
    border: 1px dashed #ccc;
    border-radius: 3px;
    background-clip: padding-box;
    background-color: #f4f4f4;
    margin-left: 10px;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
.data-zone {
    padding-left: 10px;
    width: 80%;
    max-width: 450px;
}
.data-zone h4 {
    font-weight: 700;
    line-height: 1.5em;
    font-size: 1rem;
}
.data-zone .item-description {
    clear: both;
    font-weight: 300;
    font-style: italic;
    font-size: 13px;
    width: 90%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.data-zone .float-left {
    width: 100%;
}
.verPlatos {
    position: absolute;
    right: 0;
    z-index: 11;
    cursor: pointer;
    padding: 0px 5px;
}
.botonera {
    display: flex;
    flex-direction: row;
    padding: 4px;
    position: absolute;
    bottom: 0;
    right: 0;
    align-items: center;
    z-index: 1;
}
.verPlatos .boton {
    border: 1px solid;
    padding: 5px 8px;
    margin-right: 4px;
    background: #585858;
    color: #fff;
    font-size: 0.5rem;
    border-radius: 4px;
    cursor: pointer;
}
.botonera .boton {
    border: 1px solid;
    padding: 5px 8px;
    margin-right: 4px;
    background: #585858;
    color: #fff;
    font-size: 0.5rem;
    border-radius: 4px;
    cursor: pointer;
}
.btn_pic.img {
    background-color: #585858;
    border-radius: 4px;
    width: 22px;
    margin-right: 3px;
    text-align: center;
    padding: 5px;
    i {
        font-size: 12px !important;
        color: #fff;
        margin-top: 2px;
        display: block;
    }
}
.botonera .boton.add {
    color: #fff;
    background-color: #00b04b;
    border-color: #00b04b;
    padding: 6px 6px;
}
.verPlatos .boton.save {
    color: #fff;
    background-color: #00b04b;
    border-color: #00b04b;
    padding: 4px 6px;
    font-size: 0.7rem;
    position: relative;
    // left: 6px;
    top: 3px;
}

.botonera .boton.del {
    padding: 6px 8px;
}
.botonera .boton.edit {
    padding: 4px 6px;
    font-size: 0.7rem;
}
.botonera .boton.config {
    font-size: 0.7rem;
    padding: 4px 6px;
}
/*SWICHT*/
.onoffswitch {
    position: relative;
    // width: 60px;
    width: 95px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}
.onoffswitch-checkbox {
    display: none;
}
.onoffswitch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #585858;
    border-radius: 20px;
}
.onoffswitch-inner {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.1s ease-in 0s;
}
.onoffswitch-inner:before,
.onoffswitch-inner:after {
    display: block;
    float: left;
    width: 50%;
    height: 20px;
    padding: 0;
    line-height: 20px;
    font-size: 12px;
    color: white;
    font-family: Trebuchet, Arial, sans-serif;
    font-weight: bold;
    box-sizing: border-box;
}
.onoffswitch-inner:before {
    content: "Encendido";
    padding-left: 10px;
    background-color: #585858;
    color: #ffffff;
}
.onoffswitch-inner:after {
    content: "Apagado";
    padding-right: 10px;
    background-color: #d65353;
    color: #fff;
    text-align: right;
}
.onoffswitch-switch {
    display: block;
    width: 15px;
    height: 15px;
    margin: 6px;
    background: #fff;
    position: absolute;
    top: -3px;
    bottom: 0;
    // right: 33px;
    right: inherit;
    border: 1px solid #585858;
    border-radius: 20px;
    transition: all 0.1s ease-in 0s;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
    right: 0px;
}
.botonera .boton.swich {
    padding: 0px;
    background: transparent;
}
.cdropdown.btnViewMore > a:before,
.cdropdown.btnViewMore > button:before {
    content: "" !important;
    border-top: 0px;
    border-left: 0px;
    top: 0px;
    right: 0px;
    border-right: 0px;
}
.cdropdown.btnViewMore > a,
.cdropdown.btnViewMore > button {
    padding-right: 5px;
    padding-left: 5px;
    border: 0px;
}
.cdropdown.btnViewMore ul {
    // right: -110px;
    top: 0px;
}
.noneImg {
    display: none;
}
.content-cat {
    display: flex;
    width: 96%;
    position: relative;
    z-index: 0;
}
.imgpreview {
    height: 100%;
}
.deleteImg {
    position: absolute;
    top: 0;
    left: 0;
    padding: 1px 3px;
    font-size: 8px;
    transition: 0.15s padding ease-out, 0.15s margin ease-out, 0.15s border ease-out;
}
.btns_action {
    display: flex;
    position: absolute;
    bottom: 14px;
    width: 100%;
    button {
        border: 0;
        background-color: #fff;
        cursor: pointer;
        padding: 1px 3px;
        font-size: 8px;
        border-radius: 2px;
        position: absolute;
        transition: 0.15s padding ease-out, 0.15s margin ease-out, 0.15s border ease-out;
    }
    button:nth-child(1) {
        left: 0px;
    }
    button:nth-child(2) {
        right: 0px;
    }
}
.portada-cat:hover .btns_action {
    bottom: 19px;
}
.portada-cat:hover button.deleteImg,
.portada-cat:hover .btns_action button {
    padding: 2px 6px;
    font-size: 10px;
}
.imgCropperjs {
    cursor: pointer;
    border: 1px solid #e0e0e0;
    background-color: #f1f1f1;
    text-align: center;
    overflow: hidden;
    position: relative;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}
.groupTextEmptyFont{
    background: white;
    height: 75%;
    width: 75%;    
    padding: 20px;    
    margin-top: 90px;
    margin-left: auto;
    margin-right: auto;   
}
.groupTextEmpty{
    text-align: center;
    margin-top: 30px;
    font-size: 18px;
}
.btn-add-groupEmpty{
    display: block;
    margin: 0 auto;
    background-color: #5ac146;
    border-color: #ccc;
    cursor: pointer;
    position: relative;
    color: #f6fafe;
    width: 100% !important;
}
@media (max-width: 1024px) {
    .list-category{
        height: calc(100vh - 30vw) !important;
    }      
}
@media (max-width: 1000px) {
    .data-zone .item-description {
        display: none;
    }     
}
@media (min-width: 950px) {
    .data-zone {
        width: initial;
    }
}
@media (max-width: 852px) {
    .data-zone {
        width: 75%;
        margin-bottom: 10px;
    }
    .data-zone .float-left {
        width: 90%;
    }  
}
@media (max-width: 767px) {
    .data-zone {
        width: initial;
    }  
}
@media (max-width: 540px) {
    .list-category{
        height: calc(100vh - 35vw) !important;
    }
}

@media (max-width: 485px) {
    .data-zone {
        margin-bottom: 20px;
    }  
}
@media (max-width: 409px) {
    .data-zone {
        width: 65%;
    }
}
</style>
